module.exports = __webpack_public_path__ + "img/justin_coleman.f8a00fc6.png";